import RGSProvider from "./RGS/RGSProvider";

let RGS = null;

const getRGS = async () => {
  if (!RGS) {
    try {
      RGS = RGSProvider.loadProvider();
    } catch (error) {
      throw error;
    }
  }
  return RGS;
};

export const handleInitGame = async (useApiData = false, ignoreFreeRoundsStorage = false) => {
  try {
    const rgs = await getRGS();
    const result = await rgs.initGame(useApiData, ignoreFreeRoundsStorage);
    return result;
  } catch (error) {
    throw error;
  }
};

export const handleGetSpinParams = (universalState) => {
  // RGS is already loaded by the time any spin happens (synchronous access)
  if (!RGS) {
    throw new Error("RGS not initialized. Call handleInitGame first.");
  }
  return RGS.getSpinParams(universalState);
};

export const handleGetBalanceStrategy = () => {
  // RGS is already loaded by the time any spin happens (synchronous access)
  if (!RGS) {
    throw new Error("RGS not initialized. Call handleInitGame first.");
  }
  return RGS.getBalanceStrategy();
};

export const handleShouldSyncBalanceOnWinClose = () => {
  // RGS is already loaded by the time any win animation happens (synchronous access)
  if (!RGS) {
    return true; // Fallback: sync if RGS not initialized
  }
  return RGS.shouldSyncBalanceOnWinClose?.() ?? true;
};

export const handleSpin = async (bet, token, command, purchasedFeature, options) => {
  const rgs = await getRGS();
  try {
    const result = await rgs.spin(bet, token, command, purchasedFeature, options);
    return result;
  } catch (error) {
    throw error;
  }
};

export const handleBuyFeature = async (bet) => {
  const rgs = await getRGS();
  return await rgs.buyFeature(bet);
};

export const handleSimulate = async (slotface, bet, token) => {
  const rgs = await getRGS();
  return await rgs.simulate(slotface, bet, token);
};
